import { render, staticRenderFns } from "./ConsentsIndex.vue?vue&type=template&id=69b8fce2&scoped=true"
import script from "./ConsentsIndex.vue?vue&type=script&lang=js"
export * from "./ConsentsIndex.vue?vue&type=script&lang=js"
import style0 from "./ConsentsIndex.vue?vue&type=style&index=0&id=69b8fce2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b8fce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b8fce2')) {
      api.createRecord('69b8fce2', component.options)
    } else {
      api.reload('69b8fce2', component.options)
    }
    module.hot.accept("./ConsentsIndex.vue?vue&type=template&id=69b8fce2&scoped=true", function () {
      api.rerender('69b8fce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/privacy/ConsentsIndex.vue"
export default component.exports